import React, { Component } from "react";
import banner from "../images/g-suite-banner.png";

class Hero extends Component {
  render() {
    const bannerStyle = {
      backgroundImage: `URL(${banner})`
    };
    return (
      <div className="banner" style={bannerStyle}>
        {/* <img style={bannerStyle} alt="G Suite" src={banner} /> */}
      </div>
    );
  }
}

export default Hero;
